var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargingPileLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.666 25.3333H19.9993V28H2.66602V25.3333H3.99935V5.33333C3.99935 4.97971 4.13982 4.64057 4.38987 4.39052C4.63992 4.14048 4.97906 4 5.33268 4H17.3327C17.6863 4 18.0254 4.14048 18.2755 4.39052C18.5255 4.64057 18.666 4.97971 18.666 5.33333V16H21.3327C22.0399 16 22.7182 16.281 23.2183 16.781C23.7184 17.2811 23.9993 17.9594 23.9993 18.6667V24C23.9993 24.3536 24.1398 24.6928 24.3899 24.9428C24.6399 25.1929 24.9791 25.3333 25.3327 25.3333C25.6863 25.3333 26.0254 25.1929 26.2755 24.9428C26.5255 24.6928 26.666 24.3536 26.666 24V14.6667H23.9993C23.6457 14.6667 23.3066 14.5262 23.0565 14.2761C22.8065 14.0261 22.666 13.687 22.666 13.3333V8.552L20.4567 6.34267L22.342 4.45733L28.942 11.0573C29.066 11.181 29.1644 11.3279 29.2314 11.4897C29.2984 11.6515 29.3329 11.8249 29.3327 12V24C29.3327 25.0609 28.9113 26.0783 28.1611 26.8284C27.411 27.5786 26.3935 28 25.3327 28C24.2718 28 23.2544 27.5786 22.5043 26.8284C21.7541 26.0783 21.3327 25.0609 21.3327 24V18.6667H18.666V25.3333ZM6.66602 25.3333H15.9993V6.66667H6.66602V25.3333ZM11.9993 14.6667H15.9993L10.666 22.6667V17.3333H6.66602L11.9993 9.33333V14.6667Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingPileLine);
export default __webpack_public_path__ + "static/media/charging-pile-line.b93cca1ef78bffc30e5a3ff67214fe12.svg";
export { ForwardRef as ReactComponent };